import React from 'react';
import { Box, Typography } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';

export interface EmptyStateProps {
  message?: string;
  icon?: React.ReactNode;
  height?: number;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'No data available',
  icon,
  height = 200,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: height,
        color: '#9ca3af',
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          backgroundColor: '#f3f4f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        {icon || <InboxIcon sx={{ fontSize: 32, color: '#9ca3af' }} />}
      </Box>
      <Typography
        sx={{
          fontSize: '0.875rem',
          color: '#6b7280',
          textAlign: 'center',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyState;
